import styled from 'styled-components';
import ConfigurableTrimTemplate from './ConfigurableTrimTemplate';
import { rem } from 'polished';

export const ConfigurableTrimStyled = styled(ConfigurableTrimTemplate)`
    .links-section {
        flex-direction: column;
    }

    .trim-compare {
        position: relative;

        .modalWindow__wrap__modalBody {
            padding: 0;
            display: block;
        }

        .modalWindow__wrap__header__closeBtn {
            position: fixed;
            right: 0;
            left: unset;
            top: 0;
            font-size: ${rem(19)};
            background: ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.pureWhite};
            z-index: 999999;
        }
    }
`;
